module.exports = __webpack_public_path__ + "img/button-left.fde5dcb.png";